(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-syndicate-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-syndicate-service.js');
'use strict';

const {
  jupiter
} = svs.core;
const syndicateMemberRole = {
  OWNER: 7,
  MEMBER: 4
};

const getSyndicateDataAsync = async () => {
  svs.myProfile.logger.debug('CommunicationSettingsSyndicateService:getSyndicateDataAsync start...');
  let hasSyndicate = false;
  let isSyndicateOwner = false;
  let isSyndicateMember = false;
  let syndicateNotificationSettings = {};
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/social/1/syndicates?include=customerSyndicates.memberRole'
    });
    svs.myProfile.logger.debug("getSyndicateDataAsync:syndicates status ".concat(status));
    if (response.customerSyndicates) {
      hasSyndicate = true;
      isSyndicateOwner = Boolean(response.customerSyndicates.find(syndicate => syndicate.memberRole === syndicateMemberRole.OWNER));
      isSyndicateMember = Boolean(response.customerSyndicates.find(syndicate => syndicate.memberRole === syndicateMemberRole.OWNER || syndicate.memberRole === syndicateMemberRole.MEMBER));
    }
  } catch (error) {
    svs.myProfile.logger.error('getSyndicateDataAsync error:', error);
    return {
      status: 'error',
      error
    };
  }
  if (hasSyndicate) {
    try {
      const {
        response,
        status
      } = await jupiter.callAsync({
        method: 'GET',
        path: '/social/1/notificationsettings'
      });
      svs.myProfile.logger.debug("getSyndicateDataAsync:notificationsettings status ".concat(status));
      syndicateNotificationSettings = response.notificationSettings;
    } catch (error) {
      svs.myProfile.logger.error('getSyndicateDataAsync:notificationsettings error:', error);
      return {
        status: 'error',
        error
      };
    }
  }
  return {
    status: 'success',
    isSyndicateOwner,
    isSyndicateMember,
    syndicateNotificationSettings
  };
};

const putCustomersSyndicateAsync = async notification => {
  try {
    svs.myProfile.logger.debug('putCustomersSyndicateAsync notifications:', notification);
    const path = '/social/1/notificationsettings';
    const data = {
      notificationSettings: [notification]
    };
    const response = await jupiter.callAsync({
      method: 'PUT',
      path,
      data
    });
    if (response !== null && response !== void 0 && response.error) {
      svs.myProfile.logger.error('putCustomersSyndicateAsync error response from jupiter:', response.error);
      return {
        status: 'error',
        error: response.error
      };
    }
    svs.myProfile.logger.debug('putCustomersSyndicateAsync response from jupiter');
    return {
      status: 'success'
    };
  } catch (err) {
    svs.myProfile.logger.error('putCustomersSyndicateAsync error from jupiter:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.notifications.notificationsSyndicateService = {
  getSyndicateDataAsync,
  putCustomersSyndicateAsync
};

 })(window);